import { SignatureField } from '../../../components/SignatureCanvas';
import { Text } from '../../../components/typography';
import { useState, useCallback } from 'react';
import styles from '../../../components/SignatureCanvas.module.scss';
import { keys } from '../../../utilities/translator/translation_keys';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import { uploadImageFile } from './utils';
import { useApolloClient } from '@apollo/client';

export default function SignatureNoAuth({
  onSubmit,
  disabled = false,
  showNameInput = true,
  required = false,
  preview = false,
  company = null,
}) {
  const client = useApolloClient();
  const { t } = useTranslation();
  const addImageResults = useCallback(
    (_, onSubmit, file, { signatureText }) => {
      const fileParts = file.name.split('.');
      const fileName = fileParts[0];

      uploadImageFile({
        fileUUID: fileName,
        file,
        onSubmit,
        signatureText,
        client,
        company,
      });
    },
    [client, company],
  );
  const [isSigned, setIsSigned] = useState(disabled);
  const [signatureText, setSignatureText] = useState('');

  const handleSubmitSignature = useCallback(
    (text, file) => {
      addImageResults('', onSubmit, file, {
        signatureText: text,
      });
      setIsSigned(false);
    },
    [addImageResults, onSubmit],
  );

  return (
    <div className={styles.container}>
      {!!showNameInput && (
        <>
          <Text noMargin weight="semiBold">
            {t(keys.assessments.FULL_NAME)}
          </Text>
          <Form.Control
            required
            placeholder={t(keys.action.ENTER, {
              variable: t(keys.common.NAME),
            })}
            type="text"
            value={signatureText}
            onChange={(e) => setSignatureText(e.target.value)}
            className={styles.nameInput}
          />
        </>
      )}
      <Text noMargin weight="semiBold">
        {t(keys.common.SIGNATURE)}
        {!!required ? <span className={styles.red}>*</span> : null}
      </Text>
      <SignatureField
        showNameInput={showNameInput}
        onSubmit={handleSubmitSignature}
        disabled={isSigned || preview}
        signatureText={signatureText}
        setSignatureText={setSignatureText}
        onSigned={setIsSigned}
      />
    </div>
  );
}
